import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import { setGuestCart } from "../Cart/cartStorage";
import { toast } from "react-toastify";
import "./Checkout.css";

function Checkout() {
  const location = useLocation();
  const navigate = useNavigate();

  const state = location.state;

  const cart = state?.cart || [];
  const total = state?.total || 0;
  const isBuyNow = state?.isBuyNow || false;
  console.log("cssart", cart);

  const isLoggedIn = !!localStorage.getItem("access");

  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const DELIVERY_CHARGE = total > 250 ? 0 : 50;
  const finalTotal = total + DELIVERY_CHARGE;


  const [form, setForm] = useState({
    full_name: "",
    phone: "",
    address_line1: "",
    city: "",
    state: "",
    pincode: "",
  });

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (isLoggedIn && cart.length === 0) {
      navigate("/cart");
    }
  }, [cart, isLoggedIn, navigate]);


  // Load addresses
  const loadAddresses = async () => {
    try {
      const res = await axiosInstance.get("/payment/addresses/");
      setAddresses(res.data);
      if (res.data.length && !selectedAddress) {
        setSelectedAddress(res.data[0].id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadAddresses();
  }, []);

  const saveAddress = async () => {

    if (!form.full_name || !form.phone || !form.address_line1 ||
      !form.city || !form.state || !form.pincode) {
      toast.error("Please fill all fields");
      return;
    }

    if (form.phone.length !== 10) {
      toast.error("Phone must be 10 digits");
      return;
    }

    if (form.pincode.length !== 6) {
      toast.error("Invalid pincode");
      return;
    }

    try {
      const res = await axiosInstance.post("/payment/addresses/", form);

      toast.success("Address saved successfully 🚚");

      setForm({
        full_name: "",
        phone: "",
        address_line1: "",
        city: "",
        state: "",
        pincode: "",
      });

      setShowForm(false);

      await loadAddresses();
      setSelectedAddress(res.data.id);

    } catch (err) {
      toast.error("Failed to save address");
    }
  };

  const proceedPayment = async () => {
    try {
      setLoading(true);

      const res = await axiosInstance.post("/payment/create-order/", {
        address_id: selectedAddress,
        is_buy_now: isBuyNow,

        cart: cart.map(item => ({
          product_id: item.product_id,
          quantity: item.quantity,
          color_id: item.color ? item.color.id : null,
          size_id: item.size ? item.size.id : null,
          number_plate: item.number_plate || null,
        }))
      });
      const options = {
        key: res.data.key,
        amount: res.data.amount * 100,
        currency: "INR",
        name: "StickyRoot",
        description: "Order Payment",
        image: "https://stickyroot.in/logoimg.png",
        order_id: res.data.razorpay_order_id,
        handler: async function (response) {
          try {
            await axiosInstance.post("/payment/verify-payment/", {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            if (!isBuyNow) setGuestCart([]);
            window.dispatchEvent(new Event("cartUpdated"));
            navigate("/success");
          } catch (err) {
            toast.error("Payment verification failed");
            setLoading(false);
          }
        },
      };
      setLoading(false);
      if (!window.Razorpay) {
        toast.error("Payment system failed to load");
        return;
      }

      new window.Razorpay(options).open();
    } catch (err) {
      toast.error("Order creation failed");
      setLoading(false);
    }
  };

  const handlePayment = () => {
    if (loading) return;

    if (!selectedAddress) {
      toast.error("Please select delivery address");
      return;
    }

    proceedPayment();
  };

  return (
    <div className="checkout-wrapper">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Processing payment, please wait...</p>
        </div>
      )}

      <h2 className="checkout-title">Checkout 🤝</h2>

      <div className="checkout-grid">
        {/* ADDRESS SECTION */}
        <div className="checkout-left">
          <h3>🚚 Delivery Address</h3>

          {addresses.map((addr) => (
            <div
              key={addr.id}
              className={`address-card ${selectedAddress === addr.id ? "active" : ""
                }`}
              onClick={() => setSelectedAddress(addr.id)}
            >
              <b>{addr.full_name}</b>
              <p>{addr.address_line1}</p>
              <p>
                {addr.city}, {addr.state} - {addr.pincode}
              </p>
              <span>📞 {addr.phone}</span>
            </div>
          ))}

          <button
            className="add-address-btn"
            onClick={() => setShowForm(!showForm)}
          >
            + Add New Address
          </button>
        </div>
        {showForm && (
          <div className="address-form">

            <h3>Add New Address</h3>

            <div className="form-group">
              <label>Full Name *</label>
              <input
                value={form.full_name}
                onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Phone *</label>
              <input
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Address *</label>
              <textarea
                value={form.address_line1}
                onChange={(e) => setForm({ ...form, address_line1: e.target.value })}
              />
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>City *</label>
                <input
                  value={form.city}
                  onChange={(e) => setForm({ ...form, city: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>State *</label>
                <input
                  value={form.state}
                  onChange={(e) => setForm({ ...form, state: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Pincode *</label>
                <input
                  value={form.pincode}
                  onChange={(e) => setForm({ ...form, pincode: e.target.value })}
                />
              </div>

            </div>

            <div className="address-buttons">

              <button className="save-address-btn" onClick={saveAddress}>
                Save Address
              </button>

              <button
                className="cancel-btn"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}
        {/* ORDER SUMMARY */}
        <div className="checkout-right">
          <h3>Order Summary 🛒</h3>
          <div className="summary-card">
            {cart.length > 0 &&
              cart.map((item) => (
                <div key={`${item.product_id}-${item.size?.id || ""}-${item.color?.id || ""}`} className="summary-item">
                  <span>
                    {item.title} × {item.quantity}

                    {item.color && (
                      <div style={{ fontSize: 13, marginTop: 4 }}>
                        🎨 {item.color.name}
                      </div>
                    )}

                    {item.size && (
                      <div style={{ fontSize: 13 }}>
                        📏 {item.size.name || item.size.size}
                      </div>
                    )}
                  </span>
                  <span>
                    ₹ {(item.price || 0) * item.quantity}
                  </span>
                </div>
              ))}

            {/* <div className="summary-row">
  <span>Subtotal</span>
  <span>₹ {total}</span>
</div> */}

            <div className="summary-row">
              <span>Delivery Charge</span>
              <span>
                {DELIVERY_CHARGE === 0 ? "FREE 🎉" : `₹ ${DELIVERY_CHARGE}`}
              </span>
            </div>
            <div className="summary-total">
              <strong>Total:</strong>
              <strong>₹ {finalTotal}</strong>
            </div>

            <button
              className="pay-btn"
              onClick={handlePayment}
              disabled={loading}
            >
              {loading ? "Processing..." : `💵 Pay ₹${finalTotal}`}
            </button>
          </div>
        </div>
      </div>


    </div>
  );
}

export default Checkout;